import { render, staticRenderFns } from "./temaCintura.vue?vue&type=template&id=fea20316&scoped=true&"
import script from "./temaCintura.vue?vue&type=script&lang=ts&"
export * from "./temaCintura.vue?vue&type=script&lang=ts&"
import style0 from "./temaCintura.vue?vue&type=style&index=0&id=fea20316&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea20316",
  null
  
)

export default component.exports